import { render, staticRenderFns } from "./RegistrationDetails.vue?vue&type=template&id=4d12a414&scoped=true"
import script from "./RegistrationDetails.vue?vue&type=script&lang=js"
export * from "./RegistrationDetails.vue?vue&type=script&lang=js"
import style0 from "./RegistrationDetails.vue?vue&type=style&index=0&id=4d12a414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12a414",
  null
  
)

export default component.exports